import script from "./admin-helpdesk.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-helpdesk.vue?vue&type=script&setup=true&lang=js"

import "./admin-helpdesk.vue?vue&type=style&index=0&id=33b79405&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b79405"]])

export default __exports__